import { render } from "./BuletinsTemplate.vue?vue&type=template&id=0f63805f&scoped=true"
import script from "./BuletinsTemplate.vue?vue&type=script&lang=js"
export * from "./BuletinsTemplate.vue?vue&type=script&lang=js"

import "./BuletinsTemplate.vue?vue&type=style&index=0&id=0f63805f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f63805f"]])

export default __exports__